import { Component, OnInit } from '@angular/core';
import { MasterService } from '../master.service';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
@Component({
  selector: 'app-medical-file-masters',
  templateUrl: './medical-file-masters.component.html',
  styleUrls: ['./medical-file-masters.component.scss']
})
export class MedicalFileMastersComponent implements OnInit {
  medicalFileKeys= [];
  masterParamKey;
  rowData=[];
  civilities: any;
  frameworkComponents;
  fileMasterGridApi: GridApi;
  fileMasterDefs;
  defaultColDef = {
    editable: true,
    singleClickEdit: true
  }
  masterRowData = [];
  mastrParamKeys=[];
  constructor(private masterService:MasterService,private modal: NgbModal,private toastrService: ToastrService) { 
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent
    }
  }

  ngOnInit() {
    this.masterService.getDistinctParamKeys().subscribe(response => {
      if (response && response['code']==='S0000' && response['result']) {
        let i=0;
        for(let item of response['result']){
          let jsonData={
            id:i+1,
            value:''+item.trim()
          }
          this.medicalFileKeys.push(jsonData);
          i=i+1;
        }
        this.mastrParamKeys=this.medicalFileKeys;
      }
      
    });
  }
  loadMasterValuesByKeys(key){
    this.rowData=[];
    this.masterService.getMastersByParamKey(key.value).subscribe(response => {
      if (response && response['code']==='S0000' && response['result']) {
        this.rowData = response['result'];
      }
    });
  }
  masterAddModal(addmasters) {
    //this.patientHistoryRowData = [];
    this.modal.open(addmasters, { size: 'lg',container: '.page-content' });
    if (!this.fileMasterDefs) {
      this.getFileMasterGrid();
    }

  }
  getFileMasterGrid() {
    //add diagnotic 
    this.fileMasterDefs = [
      { headerName: 'Description', field: 'value' },
      { headerName: 'Description Fr', field: 'valueFr'},
      { headerName: 'Short Key', field: 'valueShKey' }
    ];
  }
  onGridReadyPFileMaster(params) {
    this.fileMasterGridApi = params.api;
  }
  addNewFileMasterData() {
    const newRow = { value: '', valueFr: '', valueShKey: '' };
    this.masterRowData.push(newRow);
    this.fileMasterGridApi.setRowData(this.masterRowData);
  }

  saveFileMaster() {
    this.masterRowData = this.masterRowData.map(item => ({
      ...item,
      'paramKey': this.masterParamKey
    }));
    this.masterRowData=this.masterRowData.filter(item=> item.edited && item.edited===true);
    this.masterService.saveFileMaster(this.masterRowData).subscribe(res => {
      if (res && res["code"]==='0' && res["result"]) {
        this.toastrService.success("Master Values Saved Succesffully");
        //if (res["result"][0])
        for(let item of res["result"]){
          this.rowData.push(item);
        }
        this.rowData = Object.values(this.rowData.reduce((acc,c)=>(acc[c.id]=c,acc),{}));
        this.rowData = [...this.rowData];
        this.modal.dismissAll();
      }
      else {
        this.toastrService.error(res['message'], 'Error');
      }
    }, error => {
      swal.fire("Error", "Error Occured While Saving Affectation", 'error');
    })
  }
  onCellValueChanged(params: any) {
    if(!params.data.edited && params.newValue != params.oldValue){
     params.data["edited"]=true;
    }
   }
   onpFileMasterRowSelect(addmasters){
    this.getFileMasterGrid();
    this.modal.open(addmasters, { size: 'lg', container: '.page-content' });
    this.masterRowData = this.rowData;
   }
}
